<script lang="js">
  /**
   * Collection is a component that displays a collection of FABs.
   * - button will be shown as collection if it's not set to standalone.
   */
  import Container from "../components/Container.svelte";
  import Type from "../components/Type.svelte";
  export let position = "bottom-right";
  export let to_display = [];

  let { fab_animation, fab_design } = window.FAB_PLUGIN.options;
  import { responsive_check } from "../../library/function/browser";

  /**
   * FAB Active Collection (FAC)
   * - This is where the FAB that is not standalone groupped together.
   */
  let showFAC = false;
  let facStyles = {
    animation: {
      in: `animate__${fab_animation.elements.fab_active}`,
      out: `animate__${fab_animation.elements.fab_inactive}`,
      class: ``,
    },
  };

  /** handleFAB Click */
  const handleFABClick = () => {
    /** toggleFAC */
    if (showFAC) {
      facStyles.animation.class = facStyles.animation.out;
      setTimeout(function () {
        showFAC = !showFAC;
      }, 500);
    } else {
      showFAC = !showFAC;
      facStyles.animation.class = facStyles.animation.in;
    }
  };

  if (to_display.length > 1) {
    // Select the element(s) to apply the CSS to
    const elements = document.querySelectorAll(
      ".fab-container .fab-floating-button a.fab-link-container, .fab-container .fab-floating-button div.fab",
    );

    // Apply the desired styles to each element
    elements.forEach((element) => {
      element.style.minHeight = "4rem";
    });
  }
</script>

{#if to_display.length === 1}
  <Container
    display={responsive_check(to_display[0])}
    rippleAnimation={true}
    fab={to_display[0]}
    shape={to_display[0].template.shape ? to_display[0].template.shape : fab_design.template.shape}
    animation={{
      in: fab_animation.elements.fab,
    }}
  >
    <Type fab_item={to_display[0]} classNames="fab-single-collection" />
  </Container>
{:else if to_display.length >= 1}
  <div
    class="
        flex {position.includes('center') ? 'flex-row' : 'flex-col'} 
        {position.includes('center') ? 'mx-2' : 'my-2'} gap-3
        fac animate__animated {facStyles.animation.class}
    "
    style="{showFAC ? 'display:flex;' : 'display:none;'} width: auto; "
  >
    {#each to_display as fab_item, i}
      <Type {fab_item} />
    {/each}
  </div>
  <Container
    rippleAnimation={true}
    rotateAnimation={showFAC}
    shape={fab_design.template.shape}
    animation={{
      in: fab_animation.elements.fab,
    }}
    on:click={handleFABClick}
    style="min-height: 4rem !important;"
  >
    <em class={fab_design.template.icon.class} style="color: {fab_design.template.icon.color}"></em>
    <div
      class="bg-shape"
      class:fab-bg-shape-active={fab_design.template.name === "shape"}
      style="--background-color: {fab_design.template.color}"
    ></div>
  </Container>
{/if}
